import React from "react";
import { Link } from "react-router-dom";

export function Logo({ size = 36, withWordmark = true, to = "/app" }) {
  const inner = (
    <div className="flex items-center gap-2.5">
      <img
        src="/wooflect-logo.png"
        alt="Wooflect"
        style={{ width: size, height: size }}
        className="rounded-2xl shadow-sm"
      />
      {withWordmark && (
        <span
          className="font-display font-extrabold tracking-tight text-[#2D2B2A]"
          style={{ fontSize: size * 0.6 }}
        >
          Wooflect
        </span>
      )}
    </div>
  );
  if (to) return <Link to={to} data-testid="brand-logo" className="inline-flex">{inner}</Link>;
  return inner;
}
